import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useSetRecoilState } from "recoil";
import { curConsultingState, curReportState } from "../../../recoil/assessmentState";
import { reLoadState, reloadAlert, reloadSpg } from "../../../recoil/userState";
const ProposalTree = (props) => {
    //recoil
    const setReloadState = useSetRecoilState(reLoadState);
    const setReloadspg = useSetRecoilState(reloadSpg);
    const setReloadAlerts = useSetRecoilState(reloadAlert);
    const setRecoilTreeData = useSetRecoilState(curReportState);
    const setRecoilEnergyData = useSetRecoilState(curConsultingState);
    const { proposalTypeList, treeSelected, setTreeSelected, mobileTree, setMobileTree } = props;
    const [isOpen, setIsOpen] = useState(proposalTypeList === null || proposalTypeList === void 0 ? void 0 : proposalTypeList.find((item) => item.type === treeSelected.type).name);
    const treeClick = (item) => {
        setIsOpen(item.name);
        setRecoilTreeData({
            companyId: "",
            zoneId: "",
            subZoneId: "",
            name: "",
            roomId: "",
            roomName: "",
            spgId: -1,
            spgName: "",
        });
        setRecoilEnergyData({
            companyId: "",
            name: "",
            zoneId: "",
        });
        setMobileTree(false);
        setReloadspg(true);
        setReloadState(true);
        setTreeSelected(item);
        setReloadAlerts(false);
        return;
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: `box treebar pushy-menutype navy report m-none` }, { children: _jsx("div", Object.assign({ className: "lnb" }, { children: _jsx("ul", Object.assign({ className: "lnb-depth1" }, { children: proposalTypeList.map((item) => (_jsx("li", Object.assign({ className: `tooltip-link white wmax-292 ${item.name == isOpen ? "active" : ""}`, "data-tooltip": item.description }, { children: _jsx("p", Object.assign({ onClick: () => treeClick(item) }, { children: _jsx("a", { children: _jsx("span", { children: item.name }) }) })) }), item.name))) })) })) })), _jsx("div", Object.assign({ className: `box treebar menutype report m-block ${mobileTree ? "active" : ""}` }, { children: _jsx("div", Object.assign({ className: "manuarea" }, { children: _jsx("ul", Object.assign({ className: "manulist" }, { children: proposalTypeList.map((item) => (_jsx("li", Object.assign({ className: `${item.name == treeSelected.name ? "on" : ""} title-line bg-white brd-bottom-0 arrow` }, { children: _jsx("a", { children: _jsx("p", Object.assign({ onClick: () => treeClick(item) }, { children: item.name })) }) }), item.name))) })) })) }))] }));
};
export default ProposalTree;
